import React, { useState } from "react";
import { Box, Modal } from "@mui/material";
import ViewReleaseOfInformation from "./forms/ViewReleaseOfInformation";
import ViewRevoke from "./forms/ViewRevoke";
import ViewButtonSmall from "./Buttons/ViewButtonSmall";
import ReviewButtonSmall from "./Buttons/ReviewButtonSmall";

function FormLineRoiMobile(props) {
  const styleModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "80%",
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const styleModal2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "auto",
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const [showViewModal, setShowViewModal] = useState(false);
  const [showRevokeModal, setShowRevokeModal] = useState(false);

  const openViewModal = () => {
    setShowViewModal(true);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
  };

  const openRevokeModal = () => {
    setShowRevokeModal(true);
  };

  const closeRevokeModal = () => {
    setShowRevokeModal(false);
  };
  return (
    <div
      className={
        props.color === "1"
          ? "formLineMedium-Mobile2 light-grey-form"
          : "formLineMedium-Mobile2 grey-form"
      }
    >
      <Modal
        open={showViewModal}
        onClose={closeViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal}>
          <ViewReleaseOfInformation
            {...props}
            firstName={props.firstName}
            closemodal={closeViewModal}
          />
        </Box>
      </Modal>

      <Modal
        open={showRevokeModal}
        onClose={closeRevokeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal2}>
          <ViewRevoke
            documentId={props.documentId}
            subcollectionDocumentId={props.subcollectionDocumentId}
            {...props}
            firstName={props.firstName}
            closemodal={closeRevokeModal}
            clientId={props.clientId}
          />
        </Box>
      </Modal>

      <div className="formLineRoiBlock1-mobile">{props.title}</div>

      {/* <div className="formLineRoiBlock2">{props.relationship}</div> */}

      {/* <div className="formLineRoiBlock2bis">
        <CheckWithDate checked={true} content={formatDate(props.signedOn)} />        
      </div> */}

      {/* <div className="formLineRoiBlock2tris">
        <CheckWithDate
          title={props.revokedBy}
          checked={props.revoked}
          content={props.revoked ? formatDate(props.dateRevoked) : ""}
        />        
      </div> */}

      <div className="formLineRoiBlock3-mobile">
        <ViewButtonSmall handleOpen={openViewModal} />
        {props.revoked ? (
          ""
        ) : (
          <ReviewButtonSmall handleOpen={openRevokeModal} />
        )}

        {/* <CheckButton /> */}
      </div>
    </div>
  );
}

export default FormLineRoiMobile;
